namespace TabAurous.Finance {
    export interface ServiceOutwardDetailsForm {
    }

    export class ServiceOutwardDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.ServiceOutwardDetails';
    }
}
